/* @ngInject */
function Sidebar(SidebarJS, RouterService, $timeout) {
  return Object.assign({}, SidebarJS, {
    goHome() {
      RouterService.state.go('home');
      const {marketId, regionId, hasImages, availability} = RouterService.location.search();
      $timeout(() => RouterService.location.search({marketId, regionId, hasImages, availability}));
    },
  });
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.service.js